import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  isLoading: false,
  successMessage: null,
  errorMessage: null,
  tagTypes: [],
  tagTypesTotalElements: 0,
  createdId: null,
});

const { Types, Creators } = createActions({
  getTagTypesRequest: ['customerId', 'pageParams'],
  getTagTypesRequestSuccess: ['tagTypes', 'tagTypesTotalElements'],
  getTagTypesRequestFailure: ['errorMessage'],

  createTagTypeRequest: ['tagTypeInfos', 'customerId', 'pageParams'],
  createTagTypeRequestSuccess: ['createdId', 'tagTypes', 'tagTypesTotalElements', 'successMessage'],
  createTagTypeRequestFailure: ['errorMessage'],

  editTagTypeRequest: ['tagTypeInfos', 'customerId', 'pageParams'],
  editTagTypeRequestSuccess: ['tagTypes', 'tagTypesTotalElements', 'successMessage'],
  editTagTypeRequestFailure: ['errorMessage'],

  deleteTagTypeRequest: ['tagTypeId', 'customerId', 'pageParams'],
  deleteTagTypeRequestSuccess: ['tagTypes', 'tagTypesTotalElements', 'successMessage'],
  deleteTagTypeRequestFailure: ['errorMessage'],

  activateTagRequest: ['tagInfos', 'personId', 'customerId'],
  activateTagRequestSuccess: ['successMessage'],
  activateTagRequestFailure: ['errorMessage'],

  resetTagTypes: null,
});

export const getTagTypesRequest = (state) => state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const getTagTypesRequestSuccess = (state, { tagTypes, tagTypesTotalElements }) =>
  state.merge({ isLoading: false, tagTypes, tagTypesTotalElements });
export const getTagTypesRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const createTagTypeRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const createTagTypeRequestSuccess = (state, { createdId, tagTypes, tagTypesTotalElements, successMessage }) =>
  state.merge({ isLoading: false, createdId, tagTypes, tagTypesTotalElements, successMessage });
export const createTagTypeRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const editTagTypeRequest = (state) => state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const editTagTypeRequestSuccess = (state, { tagTypes, tagTypesTotalElements, successMessage }) =>
  state.merge({ isLoading: false, tagTypes, tagTypesTotalElements, successMessage });
export const editTagTypeRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const deleteTagTypeRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const deleteTagTypeRequestSuccess = (state, { tagTypes, tagTypesTotalElements, successMessage }) =>
  state.merge({ isLoading: false, tagTypes, tagTypesTotalElements, successMessage });
export const deleteTagTypeRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const activateTagRequest = (state) => state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const activateTagRequestSuccess = (state, { successMessage }) =>
  state.merge({ isLoading: false, successMessage });
export const activateTagRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const resetTags = (state) => state.merge({ personTags: [], totalElements: 0 });
export const resetTagTypes = (state) => state.merge({ tagTypes: [] });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_TAG_TYPES_REQUEST]: getTagTypesRequest,
  [Types.GET_TAG_TYPES_REQUEST_SUCCESS]: getTagTypesRequestSuccess,
  [Types.GET_TAG_TYPES_REQUEST_FAILURE]: getTagTypesRequestFailure,

  [Types.CREATE_TAG_TYPE_REQUEST]: createTagTypeRequest,
  [Types.CREATE_TAG_TYPE_REQUEST_SUCCESS]: createTagTypeRequestSuccess,
  [Types.CREATE_TAG_TYPE_REQUEST_FAILURE]: createTagTypeRequestFailure,

  [Types.EDIT_TAG_TYPE_REQUEST]: editTagTypeRequest,
  [Types.EDIT_TAG_TYPE_REQUEST_SUCCESS]: editTagTypeRequestSuccess,
  [Types.EDIT_TAG_TYPE_REQUEST_FAILURE]: editTagTypeRequestFailure,

  [Types.DELETE_TAG_TYPE_REQUEST]: deleteTagTypeRequest,
  [Types.DELETE_TAG_TYPE_REQUEST_SUCCESS]: deleteTagTypeRequestSuccess,
  [Types.DELETE_TAG_TYPE_REQUEST_FAILURE]: deleteTagTypeRequestFailure,

  [Types.RESET_TAG_TYPES]: resetTagTypes,
});

export const TagTypesTypes = Types;
export default Creators;
